import PropTypes from 'prop-types';
import React from 'react';
import { applyVerticalStyles, interpolateString } from 'ctm-util-functions';
import styles from './detailed_label.css';

const renderTags = function (content, detailedLabelStyles) {
    const trimmedTags = content.filter((tag) => tag !== '');
    const lastTagIndex = trimmedTags.size - 1;
    const tags = content.map((tag, index) => {
        // only return <span/> when tag is not an empty string "", not undefined and not null
        if (tag) {
            return (
                <React.Fragment key={tag}>
                    <span className={detailedLabelStyles.tag}>{tag}</span>
                    {   // avoid adding a divider to the last tag.
                        !(lastTagIndex === index) && (
                            <div className={detailedLabelStyles.tag_divider}>|</div>)
                    }
                </React.Fragment>
            );
        }
        return null;
    });
    return tags;
};

const DetailedLabel = function (props) {
    const { content, detailedLabel, selectedValues } = props;
    const detailedLabelStyles = applyVerticalStyles(styles, 'detailed_label');
    const titleContent = interpolateString(detailedLabel)(selectedValues);
    return (
        <>
            <span className={detailedLabelStyles.title}>
                {titleContent}
            </span>
            <div className={detailedLabelStyles.tags_container}>
                {renderTags(content, detailedLabelStyles)}
            </div>
        </>
    );
};

DetailedLabel.propTypes = {
    content: PropTypes.object,
    detailedLabel: PropTypes.string,
    selectedValues: PropTypes.object
};

export { DetailedLabel };
